import axios from 'api';
import { PHOENIXURL } from 'utils/Constants';
import { checkEnv } from 'utils/config';

const TOKEN = 'Bearer 1nj6STK4yyEdYm1tcI9eJX0HVyYr';

// Below object exposes all Phoenix API's
export const PhoenixServices = {
	getClients: async () => {
		const path = `${PHOENIXURL[checkEnv()]}v3/clients`;
		const Headerdata = { type: 'phx' };

		return axios.request({
			method: 'GET',
			url: path,
			headers: { ...Headerdata },
		});
	},
	getAccounts: async sponsorCode => {
		const path = `${
			PHOENIXURL[checkEnv()]
		}v3/accounts?sponsor-code=${sponsorCode}`;
		const Headerdata = { type: 'phx' }; // Authorization: `Bearer ${token}`

		return axios.request({
			method: 'GET',
			url: path,
			headers: { ...Headerdata },
		});
	},
	getHierarchies: async sponsorCode => {
		const path = `${
			PHOENIXURL[checkEnv()]
		}v4/account-groups?sponsor-code=${sponsorCode}`;
		const Headerdata = { type: 'phx' }; // Authorization: `Bearer ${token}`,

		return axios.request({
			method: 'GET',
			url: path,
			headers: { ...Headerdata },
		});
	},
	getBenchmarks: async accountBid => {
		const path = `${
			PHOENIXURL[checkEnv()]
		}v3/benchmarks?account-bid=${accountBid}`;
		const Headerdata = { type: 'phx' }; // Authorization: `Bearer ${token}`,

		return axios.request({
			method: 'GET',
			url: path,
			headers: { ...Headerdata },
		});
	},
	getClientDimensions: async () => {
		const path = `${PHOENIXURL[checkEnv()]}v3/client-dimensions`;
		const Headerdata = { type: 'phx' }; // Authorization: `Bearer ${token}`,

		return axios.request({
			method: 'GET',
			url: path,
			headers: { ...Headerdata },
		});
	},
	getMetrics : async payload => {
		const path = `${PHOENIXURL[checkEnv()]}v4/metrics`;
		const Headerdata = { type: 'phx' };	// Authorization:  `Bearer ${token}`,

		return axios.request({
			method: 'POST',
			url: path,
			headers: { ...Headerdata },
			data: payload,
		});
	},
};
